'use client'
export function TickDoneThin(props) {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M18.7802 2.0264L6.78019 14.0264C6.71053 14.0961 6.62782 14.1515 6.53677 14.1892C6.44572 14.2269 6.34812 14.2464 6.24956 14.2464C6.151 14.2464 6.05341 14.2269 5.96236 14.1892C5.87131 14.1515 5.78859 14.0961 5.71894 14.0264L0.468938 8.7764C0.328207 8.63567 0.249146 8.4448 0.249146 8.24578C0.249146 8.04676 0.328207 7.85588 0.468938 7.71515C0.609668 7.57442 0.80054 7.49536 0.999563 7.49536C1.19859 7.49536 1.38946 7.57442 1.53019 7.71515L6.24956 12.4355L17.7189 0.965153C17.8597 0.824422 18.0505 0.745361 18.2496 0.745361C18.4486 0.745361 18.6395 0.824422 18.7802 0.965153C18.9209 1.10588 19 1.29676 19 1.49578C19 1.6948 18.9209 1.88567 18.7802 2.0264Z"
        fill="#5368E6"
      />
    </svg>
  )
}
